// import React,{Component} from "react";

// // reactstrap components
// import {
//   Col,
//   Progress,
//   Label,
//   Button,
//   Input
// } from "reactstrap";
// import { Checkbox } from '@mui/material';
// import Sound from 'react-sound';
// import styles from "components/test.css";
// import {base,s3base} from "api.js";
// import "components/custom.css";
// import ReactHtmlParser from 'react-html-parser';
// import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns";
// class Highlight extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       isRecording: false,
//       blobURL: '',
//       isBlocked: false,
//       question:"",
//       secondCount:10,
//       recordCount:0,
//       recordId:1,
//       intervalId:0,
//       questionId:"",
//       reset:false,
//       soundStatus:true,
//       selectedValue:'',
//       answerData:[],
//       soundPer:0,
//       answerFlag:true,
//       volume:100,
//       correctFlag:true,
//       resultObj:{},
//       playbackSpeed: 1,
//       soundKey: 0,
//     };
//   }
//   componentDidMount() {
//   	var intervalId = setInterval(this.timer, 1000);
//     this.setState({intervalId: intervalId});
//   }

//   stopTest = () =>{
//     this.props.nextQuestion(this.state.resultObj);
//   }

//   static getDerivedStateFromProps(props, state) {
//   	if (props.data) {
//   		if ((state.questionId && state.questionId !== props.data.id) || props.restart) {
//   			clearInterval(state.intervalId);
//   			clearInterval(state.recordId);
//         //document.querySelectorAll('.highlight_question')[0].innerHTML= "";
//         var els = document.querySelectorAll('.highlight_question span');
//         for (var i = 0; i < els.length; i++) {
//           els[i].classList.remove('wrong-anss');
//           els[i].classList.remove('correct-anss');
//           els[i].classList.remove('blue-bg');
//           els[i].classList.remove('highlight1');
//         }
//   			return {answerData:[],correctFlag:true,recordCount:0,soundPer:0,isRecording:false,secondCount:10,questionId: props.data.id,blobURL:'',reset:true,soundStatus:true,answerFlag:true};
//   		}else{
//   			if (!state.questionId) {
//   				return {correctFlag:true,questionId: props.data.id};
//   			}
//   		}

//   		}

//   }

//   handleSongPlaying = (obj) => {
//     this.setState({soundPer:obj.position*100/obj.duration});
//   }
//   changeRange = (e) => {
//       this.setState({volume: e.target.value});
//   }
// 	timer = () => {
// 		if (this.state.secondCount === 1) {
// 			clearInterval(this.state.intervalId);
// 		}
// 		this.setState({ secondCount: this.state.secondCount -1 });
// 	}

//   handleSongFinishedPlaying = () => {
//     this.setState({'soundStatus':false});
//     this.props.soundChecked();
//     this.props.showResult();
//   }



// 	timerRecord = () => {
// 		if (this.state.recordCount === 40) {
// 			clearInterval(this.state.recordId);
// 			this.stop();
// 		}
// 		this.setState({ recordCount: this.state.recordCount + 1 });
// 	}

//   handleChange = (event) => {
//     this.setState({selectedValue: event.target.value});
//   };
// 	componentWillUnmount = () => {
// 		clearInterval(this.state.intervalId);
// 	}



//   selectSpan = (e) => {
//     let arr = this.state.answerData;
//     if (e.target.className === "highlight1" ) {
//       e.target.classList.remove("highlight1");
//       arr = arr.filter(function(val) {
//         console.log(e.target.innerHTML)
//         console.log(val)
//           return val !== e.target.innerHTML ;
//         },e);
//     }else{
//       e.target.classList.add("highlight1");
//       arr.push(e.target.innerHTML);
//     }
//     this.props.submit({'answer':arr,'correct':this.props.data.answer.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i,x){ if(x%2 ===0) { return i; } }).map(function(x){ return x.split(' ')[x.split(' ').length-1] }),html:document.querySelector('.highlight_question').innerHTML},true);
//     this.setState({answerData:arr,resultObj: {'answer':arr,'correct':this.props.data.answer.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i,x){ if(x%2 ===0) { return i; } }).map(function(x){ return x.split(' ')[x.split(' ').length-1] }),html:document.querySelector('.highlight_question').innerHTML} });
//   }

//   answergenerated = () => {
//     if (this.state.answerFlag && document.querySelectorAll('.highlight_question .correct').length > 0) {
//       this.setState({answerFlag:false});
//       let elem = document.querySelectorAll('.highlight_question span');
//       for (var i = 0; i < elem.length; i++) {
//           let hig = document.querySelectorAll('.highlight_question span')[i].classList.value;
//           let higText = document.querySelectorAll('.highlight_question span')[i].textContent;
//           if (hig == "correct hidd") {
//             document.querySelectorAll('.highlight_question span')[i-1].classList.add('blue-bg');
//           }
//       }
//       for (var i = 0; i < elem.length; i++) {
//           let hig = document.querySelectorAll('.highlight_question span')[i].classList.value;
//           let higText = document.querySelectorAll('.highlight_question span')[i].textContent;
//           let corr = "";
//           if (elem.length > (i+1)) {
//             corr = document.querySelectorAll('.highlight_question span')[i+1].classList.value;
//           }
//         if (hig.match("highlight1")) {
//             if (corr == "correct hidd") {
//               //document.querySelectorAll('.highlight_question span')[i].innerHTML = higText;
//               //document.querySelectorAll('.highlight_question span')[i].classList.add('correct-anss');
//               document.querySelectorAll('.highlight_question span')[i].classList.remove('blue-bg');
//               document.querySelectorAll('.highlight_question span')[i].classList.add('correct-anss');
//             }else{
//             //document.querySelectorAll('.highlight_question span')[i].innerHTML = higText;
//             document.querySelectorAll('.highlight_question span')[i].classList.remove('blue-bg');
//             document.querySelectorAll('.highlight_question span')[i].classList.add('wrong-anss');
//           }

//         }

//       }
//     }

//   }

//   updateCorrect = () =>{
//     this.props.submit({'answer':[],'correct':this.props.data.answer.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i,x){ if(x%2 ===0) { return i; } }).map(function(x){ return x.split(' ')[x.split(' ').length-1] }),html:''});
//     this.setState({correctFlag:false,resultObj: {'answer':[],'correct':this.props.data.answer.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i,x){ if(x%2 ===0) { return i; } }).map(function(x){ return x.split(' ')[x.split(' ').length-1]}),html:''} });
//   }

//   skip = () => {
//     clearInterval(this.state.intervalId);
//     this.setState({secondCount:0});
//   };

//   changePlaybackSpeed = (speed) => {
//     this.setState((prevState) => ({
//       soundKey: prevState.soundKey + 1
//     }));
//     this.setState({playbackSpeed: speed});
//   }

//   render() {
//   	let question ="";
//     let answer ="";
//     let correct = ""
//     if (this.props.restart) {
//       this.props.restartQue();
//     }

//     if (this.props.answer) {
//       this.answergenerated();
//     }
//     if (this.props.stopRecording) {
//       this.stopTest();
//     }
//   	if (this.props.data) {
//   		question = this.props.data.question;
//       answer = this.props.data.answer;
//       correct = answer.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter((v,k) => { if (k%2 == 1) { return v.trim(); } });
//       if (this.state.correctFlag) {
//         this.updateCorrect();
//       }
//   	}
//   	if (this.state.reset) {
//   		var intervalId = setInterval(this.timer, 1000);
// 		  this.setState({intervalId: intervalId,reset:false});
//       document.querySelectorAll("span.highlight").forEach(function (job) {
//         job.classList.remove('highlight')
//       });
//   	}
//     return (
//       <>
//       <Col xs={12}>
//       	<h4 className="infoText"></h4>
//       </Col>
//      { !this.props.resultMode && <Col xs={12}>
//       	<div className="col-lg-12 p-0 text-center">
//   		  <div className="currentStatus">
//           <p>Current Status:{this.state.soundStatus == true && this.state.secondCount !== 0 && !this.state.isRecording && ' Begining in '+this.state.secondCount+ ' seconds' }
//           {this.state.secondCount == 0 && this.state.soundStatus && ' Playing' }

//           <br></br>
//           Volume
//            <Input placeholder="Volume" type="range" min="0" defaultValue={this.state.volume} step="1" onInput={(e) => this.changeRange(e)} max="100"  />
//            <br></br>
//           <Progress color="info" value={(this.state.soundPer)} />
//           {!this.props.testMode && (
//             <div className="d-flex justify-content-between">
//               <div className='stop-btn'>
//                 {this.state.secondCount!==0 && this.state.blobURL === '' && !this.state.isRecording && <Button color="success" onClick={this.skip} size="sm">Skip</Button> }
//               </div>
//               <div className="stop-btn">
//                 <PlaybackSpeedBtns changePlaybackSpeed={this.changePlaybackSpeed} playbackSpeed={this.state.playbackSpeed} />
//               </div>
//             </div>
//           )}
//           </p>

//             </div>
//           <Col xs={12}>
//             {this.props.data && !this.props.resultMode && this.state.soundStatus && this.state.secondCount === 0 && <Sound
//               url={s3base + this.props.data.media_link}
//               playStatus={Sound.status.PLAYING}
//               onFinishedPlaying={this.handleSongFinishedPlaying}
//               onPlaying={this.handleSongPlaying}
//               volume={this.state.volume}
//               playbackRate={this.state.playbackSpeed}
//               key={this.state.soundKey}
//             />}
//           </Col>
//     		  <Col xs={12}>
//     		  	{ this.state.blobURL && <audio src={this.state.blobURL} controls="controls" />}
//     		  </Col>
//     		</div>
//       </Col> }

//       <Col xs={12}>
//       {!this.props.testMode && <h3 className="question highlight_question">{this.props.data && !this.props.resultMode && answer.replace(/<span[^>]*>?/g, ' __').replace(/<[^>]*span>?/g, '__').split(' ').map(function(item){ if(item.match(/__.*__/g)){ return  <React.Fragment>{this.props.answer && <span className="correct hidd">{item.replace(/__/g,'')}</span>}</React.Fragment> }else{ return <React.Fragment><span className="" onClick={this.selectSpan} >{item}</span>&nbsp; </React.Fragment>; }},this)}</h3>}
//       {this.props.testMode && <h3 className="question highlight_question">{this.props.data && !this.props.resultMode && answer.replace(/<span[^>]*>?/g, ' __').replace(/<[^>]*span>?/g, '__').split(' ').map(function(item){ if(item.match(/__.*__/g)){ return  <React.Fragment>{<span className="correct hidd">{item.replace(/__/g,'')}</span>}</React.Fragment> }else{ return <React.Fragment><span className="" onClick={this.selectSpan} >{item}</span>&nbsp; </React.Fragment>; }},this)}</h3>}
//       </Col>
//       <div className="col-xs-12 answers">
//       {this.props.data && this.props.data.option.map(function(item){
//               return <React.Fragment>
//                       <Label className={ this.props.answer && item.correct === 1 && 'correct-line' }>
//                         <Checkbox
//                             value={item.id}
//                             color="primary"
//                             inputProps={{ 'aria-label': 'secondary checkbox' }}
//                             name="answer"
//                           />{' '}
//                         {item.options}
//                       </Label>

//                     </React.Fragment>;
//             },this) }
//         <Col xs={12}><h5>{this.props.data && this.props.resultMode && ReactHtmlParser(answer.replace(/<span[^>]*>?/g, '<b className="correct" style="display:none">').replace(/<[^>]*span>?/g, '</b>&nbsp;').replace(/__add_blank__/g, '')) }</h5></Col>
//       </div>
//       </>
//     );
//   }
// }
// export default Highlight;

import React, { useState, useEffect, useRef } from "react";
import {Form , ProgressBar , Col , Button} from "react-bootstrap";
import { Checkbox } from '@mui/material';
import Sound from 'react-sound';
import {base, s3base} from "api.js";
import "components/custom.css";
import ReactHtmlParser from 'react-html-parser';
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns";
import { formatTimeMiliSecond } from "util/helper.js";
import { fromJSON } from "postcss/lib/postcss";

const Highlight = (props) => {
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  const [isBlocked, setIsBlocked] = useState(false);
  // const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(10);
  const [recordCount, setRecordCount] = useState(0);
  const [recordId, setRecordId] = useState(1);
  const [intervalId, setIntervalId] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [soundStatus, setSoundStatus] = useState(true);
  const [selectedValue, setSelectedValue] = useState('');
  const [answerData, setAnswerData] = useState([]);
  const [soundPer, setSoundPer] = useState(0);
  const [answerFlag, setAnswerFlag] = useState(true);
  const [volume, setVolume] = useState(100);
  const [correctFlag, setCorrectFlag] = useState(true);
  const [resultObj, setResultObj] = useState({});
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [soundKey, setSoundKey] = useState(0);
  const [remainingTime, setRemainingTime] = useState("00:00");
  const [answer, setAnswer] = useState("");
  // const [question, setQuestion] = useState("");
  const [correct, setCorrect] = useState("");
  const timerRef = useRef(null);
  const recordTimerRef = useRef(null);

  // componentDidMount equivalent
  useEffect(() => {
    const id = setInterval(timer, 1000);
    setIntervalId(id);
    timerRef.current = id;

    // componentWillUnmount equivalent
    return () => {
      clearInterval(timerRef.current);
      clearInterval(recordTimerRef.current);
    };
  }, []);

  // getDerivedStateFromProps equivalent
  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        clearInterval(timerRef.current);
        clearInterval(recordTimerRef.current);
        
        const els = document.querySelectorAll('.highlight_question span');
        for (let i = 0; i < els.length; i++) {
          els[i].classList.remove('wrong-anss');
          els[i].classList.remove('correct-anss');
          els[i].classList.remove('blue-bg');
          els[i].classList.remove('highlight1');
        }
        
        setAnswerData([]);
        setCorrectFlag(true);
        setRecordCount(0);
        setSoundPer(0);
        setIsRecording(false);
        setSecondCount(10);
        setQuestionId(props.data.id);
        setBlobURL('');
        setReset(true);
        setSoundStatus(true);
        setAnswerFlag(true);
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
        }
      }
    }
  }, [props.data, props.restart, questionId]);

  // Handle reset
  useEffect(() => {
    if (reset) {
      const id = setInterval(timer, 1000);
      setIntervalId(id);
      timerRef.current = id;
      setReset(false);
      
      document.querySelectorAll("span.highlight").forEach(function (job) {
        job.classList.remove('highlight');
      });
    }
  }, [reset]);

  // Handle restart
  useEffect(() => {
    if (props.restart) {
      props.restartQue();
    }
  }, [props.restart]);

  // Handle answer
  useEffect(() => {
    if (props.answer) {
      answergenerated();
    }
  }, [props.answer]);

  // Handle stop recording
  // useEffect(() => {
  //   if (props.stopRecording) {
  //     stopTest();
  //   }
  // }, [props.stopRecording]);

    useEffect(() => {
      if (props.stopRecording) {
        stopTest();
      }
    }, [props.stopRecording]);

  const stopTest = () => {
    props.nextQuestion(resultObj);
  };

  const handleSongPlaying = (obj) => {
    setSoundPer(obj.position * 100 / obj.duration);
    setRemainingTime(formatTimeMiliSecond(obj.duration - obj.position));
  };

  const changeRange = (e) => {
    setVolume(e.target.value);
  };

  const timer = () => {
    setSecondCount(prevCount => {
      if (prevCount <= 1) {
        clearInterval(timerRef.current);
        return 0;
      }
      return prevCount - 1;
    });
  };

  const handleSongFinishedPlaying = () => {
    setSoundStatus(false);
    props.soundChecked();
    props.showResult();
  };

  const timerRecord = () => {
    setRecordCount(prevCount => {
      if (prevCount === 40) {
        clearInterval(recordTimerRef.current);
        stop();
      }
      return prevCount + 1;
    });
  };

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const selectSpan = (e) => {
    let arr = [...answerData];
    if (e.target.className === "highlight1") {
      e.target.classList.remove("highlight1");
      arr = arr.filter(function(val) {
        console.log(e.target.innerHTML);
        console.log(val);
        return val !== e.target.innerHTML;
      }, e);
    } else {
      e.target.classList.add("highlight1");
      arr.push(e.target.innerHTML);
    }
    
    // const correctAnswers = props.data.answer.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i, x) {
    //   if (x % 2 === 0) {
    //     return i;
    //   }
    // }).map(function(x) {
    //   return x.split(' ')[x.split(' ').length - 1];
    // });
    //  const correctAnswers = Array.from(
    //   props.data.answer.matchAll(
    //     /(\b[\w'-]+)\s*<span[^>]*id=['"]cAns['"][^>]*>.*?<\/span>/g
    //   ),
    //   match => match[1]
    // );
    const temp = document.createElement("div");
      temp.innerHTML = props.data.answer;

    const correctAnswers = Array.from(temp.querySelectorAll("span#cAns")).map(span => {
      const text = span.previousSibling?.textContent || "";
      return text.trim().split(/\s+/).pop();
    });
    const result = {
      'answer': arr,
      'correct': correctAnswers,
      html: document.querySelector('.highlight_question').innerHTML
    };
    
    props.submit(result, true);
    setAnswerData(arr);
    setResultObj(result);
  };

  const answergenerated = () => {
    if (answerFlag && document.querySelectorAll('.highlight_question .correct').length > 0) {
      setAnswerFlag(false);
      let elem = document.querySelectorAll('.highlight_question span');
      
      for (let i = 0; i < elem.length; i++) {
        let hig = document.querySelectorAll('.highlight_question span')[i].classList.value;
        let higText = document.querySelectorAll('.highlight_question span')[i].textContent;
        if (hig == "correct hidd") {
          document.querySelectorAll('.highlight_question span')[i - 1].classList.add('blue-bg');
        }
      }
      
      for (let i = 0; i < elem.length; i++) {
        let hig = document.querySelectorAll('.highlight_question span')[i].classList.value;
        let higText = document.querySelectorAll('.highlight_question span')[i].textContent;
        let corr = "";
        if (elem.length > (i + 1)) {
          corr = document.querySelectorAll('.highlight_question span')[i + 1].classList.value;
        }
        
        if (hig.match("highlight1")) {
          if (corr == "correct hidd") {
            document.querySelectorAll('.highlight_question span')[i].classList.remove('blue-bg');
            document.querySelectorAll('.highlight_question span')[i].classList.add('correct-anss');
          } else {
            document.querySelectorAll('.highlight_question span')[i].classList.remove('blue-bg');
            document.querySelectorAll('.highlight_question span')[i].classList.add('wrong-anss');
          }
        }
      }
    }
  };

  const updateCorrect = () => {
    // const correctAnswers = props.data.answer.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter(function(i, x) {
    //   if (x % 2 === 0) {
    //     return i;
    //   }
    // }).map(function(x) {
    //   return x.split(' ')[x.split(' ').length - 1];
    // });
    //  const correctAnswers = Array.from(
    //   props.data.answer.matchAll(
    //     /(\b[\w'-]+)\s*<span[^>]*id=['"]cAns['"][^>]*>.*?<\/span>/g
    //   ),
    //   match => match[1]
    // );
    const temp = document.createElement("div");
      temp.innerHTML = props.data.answer;

    const correctAnswers = Array.from(temp.querySelectorAll("span#cAns")).map(span => {
      const text = span.previousSibling?.textContent || "";
      return text.trim().split(/\s+/).pop();
    });
    console.log(correctAnswers);
    
    const result = {
      'answer': [],
      'correct': correctAnswers,
      html: ''
    };
    
    props.submit(result);
    setCorrectFlag(false);
    setResultObj(result);
  };

  const skip = () => {
    clearInterval(timerRef.current);
    setSecondCount(0);
  };

  const changePlaybackSpeed = (speed) => {
    setSoundKey(prevKey => prevKey + 1);
    setPlaybackSpeed(speed);
  };

  // let question = "";
  // let answer = "";
  // let correct = "";
  
  // if (props.data) {
  //   question = props.data.question;
  //   answer = props.data.answer;
  //   correct = answer.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter((v, k) => {
  //     if (k % 2 == 1) {
  //       return v.trim();
  //     }
  //   });
  //   if (correctFlag) {
  //     updateCorrect();
  //   }
  // }
  useEffect(() => {
  if (props.data) {
    setAnswer(props.data.answer);
    setCorrect(props.data.answer.replace(/<[^>]*>?/gm, 'x_x').split('x_x').filter((v, k) => {
      if (k % 2 == 1) {
        return v.trim();
      }
    }));
    if (correctFlag) {
      updateCorrect();
    }
  }
}, [props.data, correctFlag]);

  return (
    <>
      {
        !props.resultMode && (
        <Col xs={12}>
          <h4 className="infoText"></h4>
        </Col>
        )
      }
      {!props.resultMode && (
        <Col xs={12}>
          <div className="col-lg-12 p-0 text-center">
            <div className="currentStatus d-flex justify-content-center align-items-center p-0 audio-player-section">
              {/* <p>
                Current Status:
                {soundStatus == true && secondCount !== 0 && !isRecording && ' Begining in ' + secondCount + ' seconds'}
                {secondCount == 0 && soundStatus && ' Playing'}</p>
                <br></br>
                Volume
                <Input
                  placeholder="Volume"
                  type="range"
                  min="0"
                  defaultValue={volume}
                  step="1"
                  onInput={(e) => changeRange(e)}
                  max="100"
                />
                <br></br>
                <Progress color="info" value={soundPer} /> */}
              <div className="w-100 text-white p-4">
                <div className="d-flex justify-content-end w-100 align-items-center" style={{ minHeight: "20px" }}>
                  {secondCount === 0 && blobURL === "" && !isRecording && (
                    <p className="mb-0 fs-10">{remainingTime}</p>
                  )}
                </div>
                <div className="d-flex justify-content-center align-content-center w-100 gap-3 py-1">
                  <i className="fa fa-play" aria-hidden="true"></i>
                  <div className="flex-grow-1">
                    <ProgressBar
                      style={{ backgroundColor: "#e9ecef", height: "15px" }}
                      barStyle={{ backgroundColor: "#4493e0" }}
                      now={soundPer}
                    />
                    {/* <Progress color="info" value={(soundPer)} /> */}
                  </div>
                </div>
                <div className="d-flex justify-content-start w-100 align-items-center" style={{ minHeight: "20px" }} >
                  {soundPer === 100 ? (
                    <p className="mb-0 fs-10 mx-4">Completed</p>
                  ) : soundStatus === true &&
                    secondCount !== 0 &&
                    !isRecording ? (
                    <p className="mb-0 fs-10 mx-4">
                      The clip will begin in {secondCount} seconds
                    </p>
                  ) : (
                    <p className="mb-0 fs-10 mx-4 invisible"></p>
                  )}
                </div>
                <br></br>
                <div className="w-100 d-flex justify-content-center align-items-center">
                  <div className="d-flex justify-content-center gap-3  align-items-center w-50">
                    <i className="fa fa-volume-up" aria-hidden="true"></i>
                    <Form.Control
                      placeholder="Volume"
                      type="range"
                      min="0"
                      defaultValue={volume}
                      step="1"
                      onInput={(e) => changeRange(e)}
                      max="100"
                    />
                  </div>
                </div>
              </div>

              {!props.testMode && (
                <div className="d-flex justify-content-between">
                  <div className="stop-btn">
                    {secondCount !== 0 && blobURL === "" && !isRecording && (
                      <Button variant="success" onClick={skip} size="sm">
                        Skip
                      </Button>
                    )}
                  </div>
                  <div className="stop-btn">
                    <PlaybackSpeedBtns
                      changePlaybackSpeed={changePlaybackSpeed}
                      playbackSpeed={playbackSpeed}
                    />
                  </div>
                </div>
              )}
            </div>
            <Col xs={12}>
              {props.data &&
                !props.resultMode &&
                soundStatus &&
                secondCount === 0 && (
                  <Sound
                    url={s3base + props.data.media_link}
                    playStatus={Sound.status.PLAYING}
                    onFinishedPlaying={handleSongFinishedPlaying}
                    onPlaying={handleSongPlaying}
                    volume={volume}
                    playbackRate={playbackSpeed}
                    key={soundKey}
                  />
                )}
            </Col>
            <Col xs={12}>
              {blobURL && <audio src={blobURL} controls="controls" />}
            </Col>
          </div>
        </Col>
      )}

      <Col xs={12}>
        {!props.testMode && (
          <h3 className="question highlight_question">
            {console.log("First PAragraph ------")}
            {props.data &&
              !props.resultMode &&
              answer
                .replace(/<span[^>]*>?/g, " __")
                .replace(/<[^>]*span>?/g, "__")
                .split(" ")
                .map(function (item, index) {
                  if (item.match(/__.*__/g)) {
                    console.log("If of the First Paragraph")
                    return (
                      <React.Fragment key={`span-${index}`}>
                        {props.answer && (
                          <span className="correct hidd">
                            {item.replace(/__/g, "")}
                          </span>
                        )}
                      </React.Fragment>
                    );
                  } else {
                     console.log("else of the First Paragraph")
                    return (
                      <React.Fragment key={`span-${index}`}>
                        <span className="" onClick={selectSpan}>
                          {item}
                        </span>
                        &nbsp;
                      </React.Fragment>
                    );
                  }
                })}
          </h3>
        )}
        {props.testMode && (
          <h3 className="question highlight_question result-correct mock-resource-text">
            {/* {console.log("Second Paragraph of the Highlight")} */}
            {props.data &&
              !props.resultMode &&
              answer
                // Remove spans with id="cAns" completely
                .replace(/<span[^>]*id=['"]cAns['"][^>]*>.*?<\/span>/g, "")
                // Replace other span tags with placeholders
                .replace(/<span[^>]*>?/g, " __")
                .replace(/<\/span>/g, "__")
                .split(" ")
                .map(function (item,index) {
                  if (item.match(/__.*__/g)) {
                    return (
                      <React.Fragment key={index}>
      <span className="" onClick={selectSpan}>
                          {item.replace(/__/g, "")}
                        </span>
                        &nbsp;
                      </React.Fragment>
                    );
}
                  else {
                    return (
                      <React.Fragment key={index}>
                        <span className="" onClick={selectSpan}>
                          {item}
                        </span>
                        &nbsp;
                      </React.Fragment>
                    );
                  }
                })}
          </h3>
        )}
      </Col>
      <div className="col-xs-12 answers">
        {props.data &&
          props.data.option.map(function (item) {
            return (
              <React.Fragment key={item.id}>
                <Form.Label
                  className={
                    props.answer && item.correct === 1 && "correct-line"
                  }
                >
                  <Checkbox
                    value={item.id}
                    color="primary"
                    inputProps={{ "aria-label": "secondary checkbox" }}
                    name="answer"
                  />{" "}
                  {item.options}
                </Form.Label>
              </React.Fragment>
            );
          })}
        {/* <Col xs={12}>
         {
          !props.resultMode && (
             <h5>
            {props.data &&
              props.resultMode &&
              ReactHtmlParser(
                answer
                  .replace(
                    /<span[^>]*>?/g,
                    '<b className="correct" style="display:none">'
                  )
                  .replace(/<[^>]*span>?/g, "</b>&nbsp;")
                  .replace(/__add_blank__/g, "")
              )}
          </h5>
          )
         }
        </Col> */}
      </div>
    </>
  );
};

export default Highlight;
